// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


// Top scroll Button
var elWrap = $('.anchor');

$(window).scroll(function() {
  var scrollX = $(this).scrollTop() - 1500;

  if (scrollX >= 10) {
    $(elWrap).addClass('reveal');
  } else {
    $(elWrap).removeClass('reveal');
  }
});

// Apply Smooth scroll
$('a[href*="#"]:not([href="#"])').click(function() {
  if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top,
      }, 2000);
      return false;
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js